import {
  GET_USERS,
  USER_RESPONSE_HANDLER,
  USER_DETAILS_RESPONSE_HANDLER,
  GET_SUBSCRIPTION_RESPONSE_HANDLER,
  SUBSCRIBE_RESPONSE_HANDLER,
} from "../actions/types";

export default (state = {}, action) => {
  let status = 400;
  let data = {};
  let notificationType = "info";
  if (
    action.payload != undefined &&
    typeof action.payload.status != "undefined"
  ) {
    status = action.payload.status;
    notificationType = "success";
    if (status >= 400) {
      notificationType = "error";
    }
    data = action.payload.data;
  }

  let response = {
    notificationType: notificationType,
    type: action.type,
    status: status,
    action: "LIST",
  };
  switch (action.type) {
    case GET_USERS:
      response["data"] = data.users;
      break;
    case USER_RESPONSE_HANDLER:
      response["data"] = data;
      response["action"] = "ACTION";
      break;
    case USER_DETAILS_RESPONSE_HANDLER:
      response["data"] = data.users;
      break;
    case GET_SUBSCRIPTION_RESPONSE_HANDLER:
      response["data"] = data.results;
      break;
    case SUBSCRIBE_RESPONSE_HANDLER:
      response["data"] = data;
      response["action"] = "ACTION";
      break;
    default:
      return state;
  }
  return response;
};
